// extracted by mini-css-extract-plugin
export default {"container":"ErrorComponent_container__rmeRL","wrapper":"ErrorComponent_wrapper__lSr2R","errorContainer":"ErrorComponent_errorContainer__8bJBe"};